import React from 'react';
import './App.css';
import { connect } from 'react-redux'
import { updateBoard, switchPlayer, setLevel, setWinner, setErrorMessage, setPlayerColor, setPlayOrder, setOpenPlayOrderDialog} from './actions/index';
import { styled } from '@material-ui/core/styles';
import GameBoard from "./components/GameBoard/GameBoard";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';



const MySelect = styled(Select)({
  width: '150px',
  height: '40px',
  color: '#f8fbff',
  position: 'relative',
  fontSize: '0.9rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const ColorSelect = styled(Select)({
  width: '74px',
  height: '40px',
  color: '#f8fbff',
  display: 'flex'
});


class ConnectedApp extends React.Component {
  	constructor(props) {
		super(props);
	}

	resetToSetup = () => {
		var board = [[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0],
		[0, 0, 0, 0, 0, 0]];
		this.props.setErrorMessage("");
		this.props.setWinner(0);
		this.props.updateBoard(board);
		this.props.setOpenPlayOrderDialog(true);
	}

  handleSelectLevel = (event) => {
		this.props.setLevel(event.target.value);
		this.resetToSetup();
  }

  	handleSelectColor = (event) => {
		this.props.setPlayerColor(event.target.value);
		this.resetToSetup();
	}

  render() {
  	return (
		<div className="App">
			<main className="app-shell">
				<header className="app-header">
					<div className="brand-block">
						<div className="title">Connect 4</div>
						<div className="subtitle">Choose your setup, then try to outthink Connecto-bot.</div>
					</div>
					<div className="control-bar">
						<div className="control-group">
							<div className="control-label">Difficulty</div>
							<FormControl variant="outlined">
								<MySelect
								  labelId="level-select-label"
								  id="level-select"
								  value={this.props.level}
								  onChange={this.handleSelectLevel}
								>
								  <MenuItem value={1}>Beginner</MenuItem>
								  <MenuItem value={2}>Easy</MenuItem>
								  <MenuItem value={3}>Medium</MenuItem>
								  <MenuItem value={4}>Hard</MenuItem>
								  <MenuItem value={5}>Advanced</MenuItem>
								</MySelect>
							</FormControl>
						</div>
						<div className="control-group">
							<div className="control-label">Your Color</div>
							<FormControl variant="outlined">
								<ColorSelect
								  labelId="color-select-label"
								  id="color-select"
								  value={this.props.player1Color}
								  onChange={this.handleSelectColor}
								>
								  <MenuItem value={"#7fff00"}>
								  	<div id="player-color-1"></div>
								  </MenuItem>
								  <MenuItem value={"#fc6e22"}>
								  	<div id="player-color-2"></div>
								  </MenuItem>
								  <MenuItem value={"#01ffff"}>
								  	<div id="player-color-3"></div>
								  </MenuItem>
								  <MenuItem value={"#01ffc3"}>
								  	<div id="player-color-4"></div>
								  </MenuItem>
								</ColorSelect>
							</FormControl>
						</div>
					</div>
				</header>
		     	<GameBoard />
		     	<div className="contact">quananhchau@gmail.com</div>
			</main>
	    </div>
    );
  }
}

const mapStateToProps = state => {
    return {
        level: state.botLevel,
        player1Color: state.player1Color
    }
}

const mapDispatchToProps = dispatch => {
	return {
		updateBoard: newBoard => {
			dispatch(updateBoard(newBoard))
		},
		switchPlayer: nextPlayer => {
			dispatch(switchPlayer(nextPlayer))
		},
		setLevel: newLevel => {
			dispatch(setLevel(newLevel))
		},
		setWinner: winner => {
			dispatch(setWinner(winner))
		},
		setErrorMessage: errorMessage => {
			dispatch(setErrorMessage(errorMessage))
		},
		setPlayerColor: newColor => {
			dispatch(setPlayerColor(newColor))
		},
		setOpenPlayOrderDialog: openPlayOrderDialog => {
			dispatch(setOpenPlayOrderDialog(openPlayOrderDialog))
		}
	}
}

const App = connect(mapStateToProps, mapDispatchToProps)(ConnectedApp);

export default App;
